module.exports = __webpack_public_path__ + "media/universities/ESCP-3af59553.png";